import {
  buildPath,
  buildTemplatePath,
  ListContext,
  ListContextValue,
  Page,
  PageRoute,
  pn,
  Stack,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import { Partner, PartnerIndirectCost as PartnerIndirectCostModel, PartnerViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { PartnerBasicInfo } from "../PartnerPage/PartnerBasicInfo";
import { PartnerIndirectCost } from "./PartnerIndirectCost";
import { PartnerPageHeader } from "./PartnerPageHeader";

const routeName = "partner";

export const partnerCreatePageRoute: PageRoute = {
  handle: "New Partner",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const PartnerCreatePage = () => {
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const [partner, setPartner] = useState<Partner>({} as Partner);
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [partner] });
  const [viewResource, setViewResource] = useState<PartnerViewResource>({});
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(0);
    fetchViewResource(0);
  }, []);

  const fetch = (id: number) => {
    ApiService.partners.get(id).then((response) => {
      setPartner(response);
      resetUnsavedChanges([response]);
    });
  };

  const fetchViewResource = (id: number) => {
    ApiService.partners.getViewResource(id).then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Page
      isForm
      header={
        <PartnerPageHeader
          handle={partnerCreatePageRoute.handle}
          partner={partner}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
        />
      }
    >
      <Stack spacing="lg">
        <PartnerBasicInfo
          partner={partner}
          setPartner={setPartner}
          viewResource={viewResource}
          crudMode={"edit"}
          validationErrors={validationErrors}
        />

        <PartnerIndirectCost
          indirectCost={partner?.creatingFirstIndirectCost || ({} as PartnerIndirectCostModel)}
          setIndirectCost={(employment) =>
            setPartner(
              produce((draft) => {
                draft.creatingFirstIndirectCost = employment;
              })
            )
          }
          validationErrors={validationErrors[pn<Partner>("creatingFirstIndirectCost")] || {}}
        />
      </Stack>
    </Page>
  );
};
